import * as constants from '../constants';

const initialState = {
    results: [],
    total: 0,
    isLoading: false
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCalculatorsPhyto.success: {
            return { results: action.payload.results, total: action.payload.count, isLoading: false };
        }

        case constants.getCalculatorsPhyto.error: {
            return initialState;
        }

        case constants.getCalculatorsPhyto.try: {
            return { results: [], total: 0, isLoading: true };
        }

        default:
            return state;
    }
}